import { formatUtcDatetimeToColombian } from "../../../../helpers/time";
import { Notification } from "../../../../types/types";

export const NOTIFICATIONS_TABLE_COLUMNS = [
  {
    value: (notification: Notification) =>
      notification.invoice.propertyCode || notification.invoice.contract,
    key: "contract",
    label: "Contrato",
    width: "1fr",
    minWidth: 90,
    exportTransform: (notification: Notification) =>
      notification.invoice.propertyCode || notification.invoice.contract,
  },
  {
    value: (notification: Notification) =>
      notification.invoice.customerDocumentNumber,
    key: "customerDocumentNumber",
    label: "Cédula",
    width: "1fr",
    minWidth: 120,
    exportTransform: (notification: Notification) =>
      notification.invoice.customerDocumentNumber,
  },
  {
    value: (notification: Notification) => notification.invoice.description,
    key: "description",
    label: "Descripción",
    width: "2fr",
    minWidth: 230,
    exportTransform: (notification: Notification) =>
      notification.invoice.description,
  },

  {
    value: (notification: Notification) => notification.invoiceId,
    key: "id",
    label: "ID",
    width: "1fr",
    minWidth: 130,
    exportTransform: (notification: Notification) => notification.invoiceId,
  },
  {
    value: (notification: Notification) => notification.fee,
    key: "fee",
    label: "Comisión",
    width: "1fr",
    minWidth: 100,
    exportTransform: (notification: Notification) => notification.fee,
  },
  {
    value: (notification: Notification) => notification.createdAt,
    key: "createdAt",
    label: "Fecha Envío",
    width: "1.5fr",
    minWidth: 200,
    exportTransform: (notification: Notification) =>
      formatUtcDatetimeToColombian(notification.createdAt),
  },
  {
    value: (notification: Notification) => notification.type,
    key: "type",
    label: "Tipo",
    width: "1fr",
    minWidth: 120,
    exportTransform: (notification: Notification) =>
      ({
        initial: "Inicial",
        due_soon: "Recordatorio",
        expiration_date: "Recuperación",
      }[notification.type]),
  },
  {
    value: (notification: Notification) => notification.status,
    key: "status",
    label: "Estado",
    width: "0.5fr",
    minWidth: 65,
    exportTransform: (notification: Notification) =>
      ({ pending: "Pendiente", sent: "Enviado", failed: "Error" }[
        notification.status
      ]),
  },
];
